@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.terms-checkbox-label {
  font-size: 14px;
}

.nondefault-terms-checkbox-container {
  padding-top: @space-8;
}

.terms-link-container {
  display: flex;
  gap: @space-8;
}

.terms-step-content {
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.terms-links {
  color: @wallet--terms-step--text-color;
  line-height: 1.5;
  margin-left: @space-24;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
    color: @wallet--terms-step--text-color;
  }

  .external-link-icon {
    fill: @wallet--terms-step--fill-color;
    width: 12px;
    margin-left: @space-4;
  }
}

.ups-terms-container {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  margin-top: @space-24;
  background-color: var(--gray-F9FAFB);
}
.ups-terms-label {
  margin-bottom: 8px;
}

.ups-terms-checkbox {
  height: auto;
  font-size: 14px;
  line-height: 24px;

  a {
    color: var(--blue-600);
    text-decoration: none;
    margin-left: 0;

    &:hover {
      text-decoration: underline;
    }
  }
}

.ups-terms-text {
  line-height: 20px;
}
